"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const lodash_1 = require("lodash");
const design_system_1 = require("@zapier/design-system");
const common_1 = require("../../../common");
const common_utils_1 = require("@zapier/common-utils");
const theme_1 = require("@zapier/theme");
const utils_1 = require("../../../PrettySelect/utils");
const SelectContentOnContextMenu_1 = __importDefault(require("../../../SelectContentOnContextMenu"));
const hasChildItems_1 = __importDefault(require("./hasChildItems"));
const isRootOption_1 = __importDefault(require("./isRootOption"));
const isParentOption_1 = __importDefault(require("./isParentOption"));
const Styles = common_utils_1.labelStyles(__filename, {
    optionWrapper: ({ highlighted, isRoot, isParent }) => ({
        backgroundColor: highlighted ? design_system_1.Colors.blue100 : design_system_1.Colors.transparent,
        borderRadius: theme_1.Border.radius.large,
        padding: `${theme_1.Spacing.small}px`,
        display: isRoot || isParent ? 'inline-flex' : 'flex',
        alignItems: 'center',
        '&:not(:first-of-type)': {
            paddingLeft: isRoot || isParent ? 0 : theme_1.Spacing.small,
        },
        cursor: 'pointer',
    }),
    optionInnerWrapper: {
        pointerEvents: 'none',
        width: '100%',
    },
});
const MAX_VALUE_LENGTH = 200;
const OptionLabel = ({ item }) => (common_utils_1.isolateComponent(design_system_1.Text, { fontWeight: 600, tag: "p", type: "altText900" }, utils_1.getOptionLabel(item)));
const OptionValue = ({ item }) => (common_utils_1.isolateComponent(design_system_1.Text, { color: "grey500", tag: "p", type: "altText800" },
    common_utils_1.isolateComponent(SelectContentOnContextMenu_1.default, null, item.isMissingValue
        ? 'MISSING VALUE!'
        : lodash_1.truncate(lodash_1.toString(utils_1.getOptionValue(item)), {
            length: MAX_VALUE_LENGTH,
        }))));
const Option = ({ disabled, getItemProps, item, itemsLabel, checked, groupId, highlighted, onSelectAndRemainOpen, }) => {
    const itemProps = getItemProps({ item });
    const onViewChildItems = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onSelectAndRemainOpen(item);
    };
    const isRoot = isRootOption_1.default(item);
    const isParent = isParentOption_1.default(item);
    return (common_utils_1.isolateComponent("div", Object.assign({ css: Styles.optionWrapper({ highlighted, isRoot, isParent }) }, itemProps),
        isParent && (common_utils_1.isolateComponent(design_system_1.Button, { color: "white", iconBefore: "arrowSmallLeft", onClick: onViewChildItems, size: "xsmall" }, "Go Back")),
        isRoot && !isParent && (common_utils_1.isolateComponent(design_system_1.Button, { color: "white", iconBefore: "arrowSmallUp", onClick: onViewChildItems, size: "xsmall" },
            "Go to Top ",
            itemsLabel)),
        !isRoot && !isParent && (common_utils_1.isolateComponent(react_1.Fragment, null,
            common_utils_1.isolateComponent("div", { css: Styles.optionInnerWrapper },
                common_utils_1.isolateComponent(common_1.FormLabel, { isDisabled: disabled, layout: "auto-content" },
                    common_utils_1.isolateComponent(design_system_1.Radio, { checked: Boolean(checked), disabled: disabled, name: groupId, onChange: lodash_1.noop, tabIndex: -1, value: utils_1.getOptionValue(item) }),
                    common_utils_1.isolateComponent("div", null,
                        common_utils_1.isolateComponent(OptionLabel, { item: item }),
                        common_utils_1.isolateComponent(OptionValue, { item: item })))),
            hasChildItems_1.default(item) && (common_utils_1.isolateComponent(design_system_1.IconButton, { color: "white", disabled: disabled, icon: "arrowSmallRight", label: `Show child items for ${utils_1.getOptionLabel(item)}`, onClick: onViewChildItems, tooltipPosition: "west" }))))));
};
exports.default = Option;
